import React from "react";

import { getLengthFract } from "utils/distance-utils";

interface IProps {
  position: number;
  lengthAhead: number;
  lengthBehind: number;
}

const PositionAtPoint = (props: IProps) => {
  const { position, lengthAhead, lengthBehind } = props;

  const renderLength = (length: number) => {
    if (length) {
      const integer = Math.trunc(length / 100);
      const fraction = getLengthFract(length);

      return (
        <sup>
          {Boolean(integer) && <>{integer}</>}
          {Boolean(fraction) && <>&nbsp;{fraction}</>}
        </sup>
      );
    }
    return <></>;
  };

  if (!position) return <></>;

  return (
    <>
      {position}
      {renderLength(position > 1 ? lengthBehind : lengthAhead)}
    </>
  );
};

export default React.memo(PositionAtPoint);
